import { useRouteLoaderData } from "react-router-dom";
import PageContent from "../components/PageContent";

import { redirect } from "react-router-dom";
import AdminDashboard from "../components/AdminDashboard";
import appVersion from "../AppVersion";
function HomePage() {
  const isAuthenticated = useRouteLoaderData("root");

  if (!isAuthenticated) {
    console.log("no session found ");
    console.log(isAuthenticated);
    redirect("/login");
  }
  return (
    <PageContent title="Welcome" subTitle={"to Communication & Sense"}>
      {!isAuthenticated && <p>Logged out</p>}
      {isAuthenticated && (
        <>
          <p style={{ fontSize: "0.75rem", color: "#888", margin: 0 }}>
            (v{appVersion})
          </p>
          <AdminDashboard />
        </>
      )}
    </PageContent>
  );
}

export default HomePage;
